export default{
    // http://crm.hulianzaowu.top/login
    title: 'CRM',
    // apiUrl:'http://192.168.1.199:5000/admin', //本地
    // uploadUrl:'http://192.168.1.199:5000/admin/customer/follow_upload', //本地
    // allImgUploadUrl: 'http://192.168.1.199:5000/admin/qrcode/img_upload', //本地
    apiUrl:'http://crm.api.hulianzaowu.top/admin', //线上
    uploadUrl:'http://crm.api.hulianzaowu.top/admin/customer/follow_upload', //线上
    allImgUploadUrl: 'http://crm.api.hulianzaowu.top/admin/qrcode/img_upload', //线上
    wsUrl:'ws://127.0.0.1:5678'
}